/**
 * Cron / messaging notes for appointment reminders and membership resets.
 *
 * @param {{ embedded?: boolean }} [props]
 */
export function RemindersSettingsSection({ embedded = false }) {
  const body = (
    <div className="space-y-4 text-sm text-muted-foreground">
      <p>
        Appointment reminders and membership resets run on the server schedule. Keep cron calling{' '}
        <code className="rounded bg-muted px-1.5 py-0.5 text-foreground">php artisan schedule:run</code>{' '}
        every minute.
      </p>

      <ul className="list-disc space-y-2 pl-5">
        <li>
          <code className="rounded bg-muted px-1.5 py-0.5 text-foreground">
            php artisan appointments:send-reminders
          </code>{' '}
          — every five minutes; sends due SMS/WhatsApp reminders when messaging is configured.
        </li>
        <li>
          <code className="rounded bg-muted px-1.5 py-0.5 text-foreground">php artisan membership:reset</code>{' '}
          — daily; resets recurring membership allowances.
        </li>
      </ul>

      <p>
        Channel toggles (SMS / WhatsApp) and templates are controlled under the{' '}
        <strong className="font-medium text-foreground">Messages</strong> tab in Settings (ops
        messaging). See <span className="text-foreground">docs/MEMBERSHIPS-AND-REMINDERS.md</span>{' '}
        for deploy notes.
      </p>
    </div>
  )

  if (embedded) {
    return body
  }

  return (
    <section className="salon-settings-card space-y-3 px-4 py-4 md:px-6 md:py-5">
      <h2 className="text-lg font-medium text-foreground">Reminders</h2>
      {body}
    </section>
  )
}
